const SET_PRESETS = 'SET_PRESETS';
const SET_TOTAL_COUNT = 'SET_PRESETS_TOTAL_COUNT';
const SET_LOADING = 'SET_PRESETS_LOADING';
const SET_PAGE = 'SET_PRESETS_PAGE';
const SET_ROWS_PER_PAGE = 'SET_PRESETS_ROWS_PER_PAGE';
const SET_SEARCH_TERM = 'SET_PRESETS_SEARCH_TERM';
const UPDATE_PRESET_ENABLED = 'UPDATE_PRESET_ENABLED';

export default {
    SET_PRESETS,
    SET_TOTAL_COUNT,
    SET_LOADING,
    SET_PAGE,
    SET_ROWS_PER_PAGE,
    SET_SEARCH_TERM,
    UPDATE_PRESET_ENABLED
};
